import React, { useState, useEffect, useRef } from 'react';

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const faqRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
        }
      });
    }, observerOptions);

    faqRefs.current.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => {
      faqRefs.current.forEach(el => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: 'What is VAT?',
      answer:
        'VAT (Value Added Tax) is a consumption tax added to most goods and services. Our tool helps you quickly work out the VAT amount and total price.'
    },
    {
      question: 'Can I use this VAT calculator for any country?',
      answer:
        'Yes. You can set any VAT rate you like, so it works for different countries and regions as long as you know the correct percentage.'
    },
    {
      question: 'Does the calculator store any of my data?',
      answer:
        'No. All calculations happen in your browser only. We do not store, track, or transmit your input values.'
    },
    {
      question: 'Can I remove VAT from a price that already includes it?',
      answer:
        'Yes. Use the "Price including VAT" option in the calculator to work out the net amount and the VAT portion.'
    },
    {
      question: 'Is this VAT calculator free to use?',
      answer:
        'Yes. You can use the calculator as often as you need without any cost or sign-up.'
    }
  ];

  return (
    <section className="faq" id="faq">
      <div className="faq-container">
        <h2 className="section-title">Frequently Asked Questions</h2>
        <p className="section-subtitle">
          Quick answers to common questions about using the VAT calculator
        </p>

        <div className="faq-grid">
          {faqs.map((item, index) => (
            <div
              key={item.question}
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
              ref={el => (faqRefs.current[index] = el)}
            >
              <div
                className="faq-question-wrapper"
                onClick={() => toggleFaq(index)}
              >
                <h3 className="faq-question">{item.question}</h3>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </div>
              <div className={`faq-answer-wrapper ${openIndex === index ? 'open' : ''}`}>
                <p className="faq-answer">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
